export default {
  //插槽
  slot: "scopedSlots",
  scopedSlots: "scopedSlots",
  "a-scopedSlots": "scopedSlots",
  //补全
  autoComplete: "formAutoComplete",
  "a-auto-complete": "formAutoComplete",
  //日期范围 或者单选日期
  calendar: "formCalendar",
  "a-calendar": "formCalendar",
  "a-range-picker": "formCalendar",
  //单个日期或者时间
  datePicker: "formDatePicker",
  "a-date-picker": "formDatePicker",
  //隐藏输入框
  hidden: "formHidden",
  "a-hidden": "formHidden",
  //输入框
  input: "formInput",
  "a-input": "formInput",
  //输入框
  inputNumber: "formInputNumber",
  "a-input-number": "formInputNumber",
  //下拉 多选
  multiple: "formMultiple",
  "a-multiple": "formMultiple",
  //查询
  searchList: "formSearchList",
  "a-search-list": "formSearchList",
  //下拉 单选
  select: "formSelect",
  "a-select": "formSelect",
  //计步器
  stepper: "formStepper",
  "a-stepper": "formStepper",
  //查询
  switch: "formSwitch",
  "a-switch": "formSwitch",
  //下拉 级联
  treeSelect: "formTreeSelect",
  "a-tree-select": "formTreeSelect",
  // textarea: "formTextarea",
  // "a-textarea": "formTextarea",
}
